module.exports = __webpack_public_path__ + "fonts/source-sans-pro-v21-latin-300.72ac20f4.ttf";